import { createVuetify } from 'vuetify'
import type { ThemeDefinition } from 'vuetify'

const themes: Record<'light' | 'dark', ThemeDefinition> = {
  light: {
    dark: false,
    colors: {
      primary: '#48D6F3',
      'on-primary': '#0D0D1E',
      secondary: '#0D0D1E',
      'on-secondary': '#FFFFFF',
      success: '#22C55E',
      'on-success': '#FFFFFF',
      info: '#00BAD1',
      'on-info': '#FFFFFF',
      warning: '#F59E0B',
      'on-warning': '#FFFFFF',
      error: '#EF4444',
      'on-error': '#FFFFFF',
      background: '#F2F2F7',
      'on-background': '#0D0D1E',
      surface: '#FFFFFF',
      'on-surface': '#0D0D1E',
    },
  },
  dark: {
    dark: true,
    colors: {
      primary: '#48D6F3',
      'on-primary': '#0D0D1E',
      secondary: '#0D0D1E',
      'on-secondary': '#FFFFFF',
      success: '#22C55E',
      'on-success': '#FFFFFF',
      info: '#00BAD1',
      'on-info': '#FFFFFF',
      warning: '#F59E0B',
      'on-warning': '#0D0D1E',
      error: '#EF4444',
      'on-error': '#FFFFFF',
      background: '#0D0D1E',
      'on-background': '#F2F2F7',
      surface: '#141427',
      'on-surface': '#F2F2F7',
    },
  },
}

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: true,
    theme: {
      defaultTheme: 'light',
      themes,
    },
  })

  nuxtApp.vueApp.use(vuetify)
})
